// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3W8dt","footer":"ModalError_footer__XwJO2"};